export default __webpack_public_path__ + "static/media/service-icon-4A.c10f58b7.png";